<script>
import { modalComputed, modalMethods } from '@state/helpers';

export default {
  components: {},
  props: {
    num: {
      type: Number,
      required: true,
      default: 0,
    },
    currentSetIndex: {
      type: Number,
      required: true,
      default: 0,
    },
    type: {
      type: String,
      required: true,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...modalComputed,
  },
  mounted() {},
  methods: {
    ...modalMethods,
    async editModal(type) {
      if (type === 'reps') {
        await this.setConfirmationModalCtx({
          type: 'reps',
          data: {
            value: this.num,
            currentSetIndex: this.currentSetIndex,
          },
        });
        this.$bvModal.show('confirmation-modal');
      }
      if (type === 'weight') {
        await this.setConfirmationModalCtx({
          type: 'weight',
          data: {
            value: this.num,
            currentSetIndex: this.currentSetIndex,
          },
        });
        this.$bvModal.show('confirmation-modal');
      }
    },
  },
};
</script>

<template>
  <div class="active-exercise-metric">
    <h2 @click="editModal(type)">
      {{ num }}
      <small>
        {{ type === 'weight' ? 'Lbs' : 'Reps' }}
        <span>
          <BaseIcon class="icon-arrow" name="arrow-circle-right" />
        </span>
      </small>
    </h2>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.active-exercise-metric {
  text-align: center;

  h2 {
    @include calc-font-size(9.5);

    color: white;
    font-weight: 800;
    line-height: 10rem;
    margin-bottom: 2rem;

    small {
      color: rgba(white, 0.5);
      display: block;
      font-family: $roboto;
      font-size: 1.5rem;
      font-style: normal;
      font-weight: bold;
      letter-spacing: 0.5px;
      line-height: 1.8rem;
      position: relative;
      text-transform: uppercase;
      top: -1.2rem;
    }

    .icon-arrow:hover {
      cursor: pointer;
    }
  }
}
</style>
